if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onPrevClick = () => this.navigateModal(-1);
        this.onNextClick = () => this.navigateModal(1);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        this.touchStartX = 0;
        this.touchStartY = 0;
      }

      connectedCallback() {
        super.connectedCallback();
        if (this.modalNavBound) return;
        this.modalNavBound = true;

        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.prevButton?.addEventListener('click', this.onPrevClick);
        this.nextButton?.addEventListener('click', this.onNextClick);
        this.addEventListener('keydown', this.onKeyDown);
        window.addEventListener('resize', this.onWindowResize);

        const content = this.querySelector('.product-media-modal__content');
        content?.addEventListener('touchstart', this.onTouchStart, { passive: true });
        content?.addEventListener('touchend', this.onTouchEnd, { passive: true });
      }

      onWindowResize() {
        if (!this.hasAttribute('open')) return;
        const mediaElements = this.getModalMediaElements();
        this.setNavVisibility(mediaElements.length);
      }

      getModalMediaElements() {
        const container = this.querySelector('[role="document"]');
        if (!container) return [];
        return Array.from(
          container.querySelectorAll(
            ':scope > img[data-media-id], :scope > deferred-media[data-media-id], :scope > .product-media-modal__model[data-media-id]'
          )
        );
      }

      findActiveIndex(mediaElements) {
        const i = mediaElements.findIndex((el) => el.classList.contains('active'));
        return i >= 0 ? i : 0;
      }

      updateCounter(counterEl, index, total) {
        if (!counterEl) return;
        if (total > 1 && index >= 0) {
          counterEl.textContent = `${index + 1} / ${total}`;
          counterEl.removeAttribute('hidden');
        } else {
          counterEl.textContent = '';
          counterEl.setAttribute('hidden', '');
        }
      }

      setNavVisibility(total) {
        if (!this.prevButton || !this.nextButton) return;
        const show = total > 1 && window.matchMedia('(max-width: 749px)').matches;
        if (show) {
          this.prevButton.removeAttribute('hidden');
          this.nextButton.removeAttribute('hidden');
        } else {
          this.prevButton.setAttribute('hidden', '');
          this.nextButton.setAttribute('hidden', '');
        }
      }

      navigateModal(delta) {
        const mediaElements = this.getModalMediaElements();
        if (mediaElements.length <= 1) return;
        const current = this.findActiveIndex(mediaElements);
        const next = (current + delta + mediaElements.length) % mediaElements.length;
        this.activateMediaAtIndex(next);
      }

      onKeyDown(event) {
        if (!this.hasAttribute('open')) return;
        const mediaElements = this.getModalMediaElements();
        if (mediaElements.length <= 1) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.navigateModal(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.navigateModal(1);
        }
      }

      onTouchStart(event) {
        if (!this.hasAttribute('open')) return;
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const t = event.touches?.[0];
        if (!t) return;
        this.touchStartX = t.clientX;
        this.touchStartY = t.clientY;
      }

      onTouchEnd(event) {
        if (!this.hasAttribute('open')) return;
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const mediaElements = this.getModalMediaElements();
        if (mediaElements.length <= 1) return;
        const t = event.changedTouches?.[0];
        if (!t) return;
        const dx = t.clientX - this.touchStartX;
        const dy = t.clientY - this.touchStartY;
        const threshold = 50;
        if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;
        if (dx > 0) {
          this.navigateModal(-1);
        } else {
          this.navigateModal(1);
        }
      }

      activateMediaAtIndex(targetIndex) {
        const container = this.querySelector('[role="document"]');
        const counterEl = this.querySelector('.product-media-modal__counter');
        const mediaElements = this.getModalMediaElements();
        if (!container || mediaElements.length === 0) return;

        const len = mediaElements.length;
        const index = ((targetIndex % len) + len) % len;

        window.pauseAllMedia();

        mediaElements.forEach((el) => el.classList.remove('active'));
        const activeMedia = mediaElements[index];
        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        container.scrollTop = 0;
        if (window.matchMedia('(min-width: 750px)').matches) {
          const mediaWidth = activeMedia.clientWidth || activeMedia.width || 0;
          container.scrollLeft = Math.max(0, (mediaWidth - container.clientWidth) / 2);
        } else {
          container.scrollLeft = 0;
        }

        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        this.updateCounter(counterEl, index, len);
        this.setNavVisibility(len);

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      showActiveMedia() {
        if (!this.openedBy) return;
        const activeId = this.openedBy.getAttribute('data-media-id');
        const mediaElements = this.getModalMediaElements();
        let index = mediaElements.findIndex((el) => el.getAttribute('data-media-id') == activeId);
        if (index < 0) index = 0;
        this.activateMediaAtIndex(index);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
    }
  );
}
